import React from "react";
import ExpandMoreIcon from "@material-ui/core/SvgIcon/SvgIcon";
import {withStyles} from "@material-ui/core";
import MuiAccordion from "@material-ui/core/Accordion/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary/AccordionSummary";
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import {action_order, apiURL, contractId, CORSSupport, userID, userLogin, userPassword} from "../configurationConstant";
import {Link} from 'react-router-dom';
import {setOrder, setOrderItem} from "../store/actions/order_actions";
import {connect} from "react-redux";
import {getStep} from "../Containers/OrderIDPage";

export const PrependZeros = function (str, len, seperator) {
    if(typeof str === 'number' || Number(str)){
        str = str.toString();
        return (len - str.length > 0) ? new Array(len + 1 - str.length).join('0') + str: str;
    }
    else{
        for(let i = 0,spl = str.split(seperator || ' '); i < spl.length; spl[i] = (Number(spl[i])&& spl[i].length < len)?PrependZeros(spl[i],len):spl[i],str = (i === spl.length -1)?spl.join(seperator || ' '):str,i++);
        return str;
    }
};

const Accordion = withStyles({
    root: {
        border: 'none',
        boxShadow: 'none',
        marginBottom: 0,
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
    root: {
        borderBottom: '1px dotted black',
        margin: '0 15px',
        padding: 0,
        fontWeight:'normal',
        minHeight: 40,
        '&$expanded': {
            marginTop: 12,
            minHeight: 40,
            margin: 0,
            fontWeight:'bold',
            padding: '0 16px',
            borderBottom: 'none',
            background: '#A0DAB3'
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
    expandIcon: {
        display: 'none'
    }
})(MuiAccordionSummary);

const AccordionDetails = withStyles(() => ({
    root: {
        padding: '0 15px',
    },
}))(MuiAccordionDetails);

class OrderItem extends React.Component{
    constructor(props){
        super(props);
        this.handleChangeField = this.handleChangeField.bind(this);
        this.setData = this.setData.bind(this);
        this.getOrderValue = this.getOrderValue.bind(this);
        const status_class =  getStatus(props.data.status);
        this.state ={
            close: false,
            status: status_class,
            price: 0,
            count: 0
        };
    }

    componentDidMount(): void {
        let flag = true;
        let order = this.props.order.order_items.filter(item => {
            return item.orderid === this.props.data.orderid
        });
        if (order.length > 0) {
            flag = false;
        }
        if (flag)
            this.getOrderValue();
        else {
            this.setState({
                price: order[0].price.toFixed(2),
                order_item: order[0],
                count:order[0].count,
                status: getStatus(order[0].status)
            })
        }
    }

    getOrderValue(){
        let headers = new Headers();
        headers.append('Content-Type','application/x-www-form-urlencoded');
        fetch( apiURL  , {
            method: "post",
            headers: headers,
            body: 'action=' + action_order + '&contract=' + contractId + '&log=' + userLogin + '&pwd=' + userPassword +
                '&user=' + userID + '&order=' + this.props.data.orderid ,
            mode: 'cors',
        }).then(r => {
            if (r.status === 200)
                return r.json().then((data) => {
                    this.setData(data);
                })
        }).catch(r => console.log(r));
    }

    setData(data){
        let price = 0;
        let count = 0;
        data.details.forEach(function (item) {
            let id = item.catalogid;
            item.services[id].forEach(position =>{
                console.log(position.order_price)
                price += Number(Number(position.order_price) * Number(position.count_order));
                count += Number( position.count_order);
            })

        });
        this.setState({
            price: price.toFixed(2),
            order_item: data,
            count: count,
            status: getStatus(data.status)
        });
        this.props.setOrder({status: getStep(data.status), express: count, priming: count, price: price});
        this.props.setOrderItem({orderid: data.orderid, price: price, count: count, status: getStatus(data.status)});
    }

    handleChangeField = (panel) => (event, newExpanded) => {
        newExpanded ?this.setState({expanded: panel,close: panel}): this.setState({expanded: false,close: false})
    };

    render() {
        const {data} = this.props;
        return(
            <div>
                    <Accordion square className={"request"} onChange={this.handleChangeField('panel1')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                        >
                            <div className={"title_position"} ><div>Заявка №{PrependZeros(Number(data.number),5)} </div>{!this.state.close?(
                                <div className={"status " +getStatus(data.status).status} >{getStatus(data.status).name}</div>
                            ):undefined}</div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div style={{width: '100%'}}>
                                <div>
                                    <div className={"request_description_field"}>
                                        <p>Дата размещения</p>
                                        <p>{String(data.order_create_date).split(" ")[0]}</p>
                                    </div>
                                    <div className={"request_description_field "}>
                                        <p>Статус</p>
                                        <Link to={'/order/' + data.orderid}>
                                            <div className={"status "  + getStatus(data.status).status}>{getStatus(data.status).name}</div>
                                        </Link>
                                    </div>
                                    <div className={"request_description_field"}>
                                        <p>Сумма ₽</p>
                                        <p>{this.state.price}</p>
                                    </div>
                                    <div className={"request_description_field"}>
                                        <p>Дата завершения</p>
                                        <p>{(String(data.order_complete_date).split(" ")[0] === 'null' ||
                                            String(data.order_complete_date).split(" ")[0] === null) ? 'Не завершена' : String(data.order_complete_date).split(" ")[0]}</p>
                                    </div>
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                    <Link  to={'/order/' + data.orderid} className={'order_item'}>
                        <p> №{PrependZeros(Number(data.number),5)} </p>
                        <p>{String(data.order_create_date).split(" ")[0]}</p>
                        <p>{(String(data.order_complete_date).split(" ")[0] === 'null' ||
                            String(data.order_complete_date).split(" ")[0] === null) ? '' : String(data.order_complete_date).split(" ")[0]}</p>
                        <p>{this.state.price}</p>
                        <Link to={'/order/' + data.orderid} >
                            <div className={"status "  + getStatus(data.status).status}>{getStatus(data.status).name}</div>
                        </Link>
                    </Link>
            </div>
        )
    }

}

export function getStatus(value) {
    let answer = {name: '', status:''};
    switch (value) {
        case '100':
        case '150':
            answer.name = 'Создание';
            answer.status = 'waiting_status';
            break;
        case '200':
        case '250':
            answer.name = 'Обработка';
            answer.status = 'treatment_status';
            break;
        case '400':
        case '450':
        case '500':
        case '600':
        case '700':
        case '800':
        case '900':
            answer.name = 'Выполнение';
            answer.status = 'performance_status';
            break;
        case '950':
        case '960':
            answer.name = 'Оплата';
            answer.status = 'payment_status';
            break;
        case '1000':
        case '10000':
            answer.name = 'Завершена';
            answer.status = 'completed_status';
            break;
        default:
            answer.name = 'Создание';
            answer.status = 'waiting_status';
            break;
    }
    return answer;
}

export function setStatus(value) {
    switch (value) {
        case "Завершена":
            return "completed_status";
        case "Размещена":
            return "posted_status";
        case "Оплата":
            return "payment_status";
        case "Выполнение":
            return "performance_status";
        case "Активный":
            return "performance_status";
        case "Ожидает размещения":
            return "waiting_status";
        case "Обработка":
            return "treatment_status";
        case "Возвращена":
            return "returned_status";
        case "Выполнена":
            return "fulfillment_status";
        default:
            return "returned_status"
    }

}

const mapStateToProps = store => {
    return{
        cart: store.cart,
        order: store.order
    }
};

const mapDispatchToProps = dispatch => {
    return{
        setOrder: (order) => dispatch(setOrder(order)),
        setOrderItem: (order) => dispatch(setOrderItem(order)),
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(OrderItem)
